module.exports = __webpack_public_path__ + "static/media/largebendelphone68h.7d229cf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Bendel/largebendelphone68h.jpg
// module id = 5749
// module chunks = 0